import { createSlice } from "@reduxjs/toolkit";
import { invoiceFormData } from "../../clientAdmin/components/invoice/invoiceUntils";

export const initialDepositInvoiceLocalState = {
  invoice_type: "deposit",
  due_date: null,
  total_amount: null, // Deposit Amount
  status: null, // or Outstanding
  method: null,
  lead_id: null,
  quote_id: null,
  customer_id: null,
  quote_amount: null,
  quote_primary_task: null,
  address: { id: null },
};

export const initialInvoiceLocalState = {
  invoice_type: "",
  lead_id: null,
  quote_id:null,
  invoice_date: null,
  due_date: null,
  net: null,
  vat_amount: null,
  total_amount: null,
  status: "Outstanding",
  is_vat_included: false,
  method: "",
  zero_vat: null,
  pay_date: null,
  insurance_amount: null,
  deposit_outstanding_balance: null,
  is_values_fixed: false,
  items_price: null,
  items_vat: null,
  items_total: null,
  customer_name: "",
  customer_email: "",
  address: {
    building_number: "",
    street: "",
    town: "",
    county: "",
    postcode: "",
    country: "",
  },
  payment_terms: "Payment due on presentation of invoice",
};

export const initialCreditInvoiceLocalState = {
  invoice_type: "credit",
  due_date: null,
  lead_id: null,
  customer_id: null,
  net: null,
  vat_amount: null,
  total_amount: null,
  status: "Outstanding",
  is_vat_included: false,
  method: "",
  zero_vat: null,
  pay_date: null,
  insurance_amount: null,
  deposit_outstanding_balance: null,
  is_values_fixed: false,
  items_price: null,
  items_vat: null,
  items_total: null,
  customer_name: "",
  customer_email: "",
  reason: "",
  reference_invoices: [],
  address: {
    building_number: "",
    street: "",
    town: "",
    county: "",
    postcode: "",
    country: "",
  },
  payment_terms: "Payment due on presentation of invoice",
};

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState: {
    invoices: [],
    newDepositInvoice: initialDepositInvoiceLocalState,
    depositInvoice: [],
    customersList: [],
    invoicePaginations: {},
    invoiceTotalPaid: null,
    invoiceTotalUnpaid: null,
    invoiceTotalAmount: null,
    invoiceTotalOutstanding: null,
    invoiceTotalPayments: null,
    isAddInvoiceResponse: false,
    isUpdateInvoiceResponse: false,
    isInvoiceError: false,
    invoiceDetails: null,
    isFileDownloaded: false,
    isUploadedToQuickBook: false,
    isUploadQuickBookError: false,
    isInvoiceSendEmailResponse: false,
    isDeletedInvoiceResponse: false,
    isDepositInvoiceCreated: false,
    isBulkInvoiceResponse: false,
    isSyncBulkInvoiceResponse: false,
    dboLinkResponse: null,
    syncBulkFailedResponse: [],
    customerInvoices: [],
    isAllInvoiceListLoading: false,
  },

  reducers: {
    getAllInvoiceListAction: (state, { payload }) => {},
    setAllInvoiceListAction: (state, { payload }) => {
      console.log("payload", payload);
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.invoices = list;
      state.invoicePaginations = pagination;
      state.invoiceTotalPaid = payload?.totalPaid;
      state.invoiceTotalUnpaid = payload?.totalUnpaid;
      state.invoiceTotalAmount = payload?.totalAmount;
      state.invoiceTotalOutstanding = payload?.totalOutstandingAmount;
      state.invoiceTotalPayments = payload?.totalPayments;
    },

    setAllInvoiceListLoading: (state, { payload }) => {
      state.isAllInvoiceListLoading = payload;
    },

    addInvoiceAction: (state, { payload }) => {},
    setAddInvoiceResponse: (state, { payload }) => {
      state.isAddInvoiceResponse = payload;
    },

    getAllCustomerListAction: (state, { payload }) => {},
    setAllCustomerListAction: (state, { payload }) => {
      state.customersList = payload;
    },

    getSingleInvoiceAction: (state, { payload }) => {},
    setSingleInvoiceAction: (state, { payload }) => {
      state.invoiceDetails = {
        ...invoiceFormData,
        ...payload,
        created_at: payload?.invoice_date || new Date(),
        // ✅ Reference invoices (convert object → string array)
        reference_invoices: payload?.reference_invoices
          ? payload.reference_invoices.map((inv: any) => inv.invoice_number)
          : [],
        total_invoice_amount: payload?.reference_invoices
          ? payload.reference_invoices.reduce(
              (acc: any, inv: any) => Number(acc) + Number(inv.total_amount || 0),
              0
            )
          : 0,
        // items: payload?.items ? payload?.items : [{
        //   ...invoiceFormData?.items[0],
        //   vat_rate: payload?.vat_percent
        // }]
      };
    },

    uploadToQuickBookAction: (state, { payload }) => {},
    setUploadToQuickBookAction: (state, { payload }) => {
      state.isUploadedToQuickBook = payload;
    },

    DBOConnectQuickBookAction: (state, { payload }) => {},
    setDBOConnectQuickBookAction: (state, { payload }) => {
      state.dboLinkResponse = payload;
    },

    deleteInvoiceAction: (state, { payload }) => {},
    setDeletedInvoiceResponse: (state, { payload }) => {
      state.isDeletedInvoiceResponse = payload;
    },

    setErrorUploadToQuickBookAction: (state, { payload }) => {
      state.isUploadQuickBookError = payload;
    },

    downloadInvoiceAction: (state, { payload }) => {},
    setDownloadInvoiceAction: (state, { payload }) => {
      state.isFileDownloaded = payload;
    },

    sendInvoiceEmailAction: (state, { payload }) => {},
    setSendInvoiceEmailResponse: (state, { payload }) => {
      state.isInvoiceSendEmailResponse = payload;
    },

    addDepositInvoiceAction: (state, { payload }) => {},
    setDepositInvoiceCreated: (state, { payload }) => {
      state.isDepositInvoiceCreated = payload;
    },

    setNewDepositInvoice: (state, { payload }) => {
      state.newDepositInvoice = {
        ...state.newDepositInvoice,
        ...payload,
      };
    },

    bulkInvoiceAction: (state, { payload }) => {},
    setBulkInvoiceResponse: (state, { payload }) => {
      state.isBulkInvoiceResponse = payload;
    },

    syncBulkInvoiceAction: (state, { payload }) => {},
    setSyncBulkInvoiceResponse: (state, { payload }) => {
      state.isSyncBulkInvoiceResponse = payload;
    },
    setSyncBulkFaildedResponse: (state, { payload }) => {
      state.syncBulkFailedResponse = payload;
    },

    getInvoiceListByCustomerIdAction: (state, { payload }) => {},
    getInvoiceListResponseByCustomerId: (state, { payload }) => {
      state.customerInvoices = payload;
    },
  },
});

const {
  getAllInvoiceListAction,
  setAllInvoiceListLoading,
  setAllInvoiceListAction,
  addInvoiceAction,
  setAddInvoiceResponse,
  getSingleInvoiceAction,
  setSingleInvoiceAction,
  downloadInvoiceAction,
  setDownloadInvoiceAction,
  uploadToQuickBookAction,
  setUploadToQuickBookAction,
  setErrorUploadToQuickBookAction,
  sendInvoiceEmailAction,
  setSendInvoiceEmailResponse,
  deleteInvoiceAction,
  setDeletedInvoiceResponse,
  addDepositInvoiceAction,
  setDepositInvoiceCreated,
  getAllCustomerListAction,
  setAllCustomerListAction,
  bulkInvoiceAction,
  setBulkInvoiceResponse,
  syncBulkInvoiceAction,
  setSyncBulkInvoiceResponse,
  setSyncBulkFaildedResponse,
  getInvoiceListByCustomerIdAction,
  getInvoiceListResponseByCustomerId,
  DBOConnectQuickBookAction,
  setDBOConnectQuickBookAction,
} = invoiceSlice.actions;
export {
  getAllInvoiceListAction,
  setAllInvoiceListLoading,
  setAllInvoiceListAction,
  addInvoiceAction,
  setAddInvoiceResponse,
  getSingleInvoiceAction,
  setSingleInvoiceAction,
  downloadInvoiceAction,
  setDownloadInvoiceAction,
  uploadToQuickBookAction,
  setUploadToQuickBookAction,
  setErrorUploadToQuickBookAction,
  sendInvoiceEmailAction,
  setSendInvoiceEmailResponse,
  deleteInvoiceAction,
  setDeletedInvoiceResponse,
  addDepositInvoiceAction,
  setDepositInvoiceCreated,
  getAllCustomerListAction,
  setAllCustomerListAction,
  bulkInvoiceAction,
  setBulkInvoiceResponse,
  syncBulkInvoiceAction,
  setSyncBulkInvoiceResponse,
  setSyncBulkFaildedResponse,
  getInvoiceListByCustomerIdAction,
  getInvoiceListResponseByCustomerId,
  DBOConnectQuickBookAction,
  setDBOConnectQuickBookAction,
};

export default invoiceSlice.reducer;
